import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
export var getLocaleId = function() {
    return getGlobalProperty("localeId");
};
